module.exports = {
    init: () => {
        // get each lane toggle button elements
        const laneToggleButtonsClass     = ".process_map__lane__line__toggle";
        const laneToggleButtonsOpenClass = "process_map__lane__line--active";
        const laneToggleButtons          = document.querySelectorAll(laneToggleButtonsClass);
        if (!laneToggleButtons) {
            console.error(`Could not find any buttons with the selector: ${laneToggleButtonsClass}`);
            return;
        };
        // for each lane toggle button element, on click:
        for (let i = 0; i < laneToggleButtons.length; i++) {
            laneToggleButtons[i].onclick = () => {
                // toggle lane line (parent of toggle button) active class on element
                laneToggleButtons[i].parentElement.classList.toggle(laneToggleButtonsOpenClass);
            };
        }
    }
};
